import PropTypes from 'prop-types'
import { validarRangoFechas } from '../../helpers/dateValidation'
import { formatearFecha } from '../helpers/helper'
import styles from './ItemLista.module.css'

const MS_SEGUNDO = 1000
const SEGUNDOS_MINUTO = 60
const MINUTOS_HORA = 60
const HORAS_DIA = 24
const DIAS_ALERTA = 7

export const ItemLista = ({
  lista,
  onEditar,
  onEliminar,
  esVenta = false,
  onVerItems,
  muestraNombreVendedor
}) => {
  if (!lista) {
    return null
  }

  const cantidadItemsCalc = () => {
    const countFields = [
      lista.cantidadItems,
      lista.cantItems,
      lista.totalItems,
      lista.totalPublicaciones,
      lista.total
    ]
    const hasCountField = countFields.some((v) => v !== undefined && v !== null)
    const num = Number(countFields.find((v) => v !== undefined && v !== null) ?? 0)

    const arrays = [lista.grilla, lista.items, lista.publicaciones]
    const arraysWithData = arrays.filter((a) => Array.isArray(a))
    const maxArray = arraysWithData.reduce((acc, arr) => Math.max(acc, arr.length), 0)
    const hasArray = arraysWithData.length > 0

    if (!hasCountField && !hasArray) {
      return null
    }
    return Math.max(num, maxArray)
  }

  const cantidadItems = cantidadItemsCalc()
  const titulo = lista.nombre ?? lista.nombreLista ?? 'Sin nombre'

  const verificarVencimiento = () => {
    if (!lista.vigenciaHasta) {
      return null
    }
    const fechaHasta = new Date(lista.vigenciaHasta)
    const hoy = new Date()
    hoy.setHours(0, 0, 0, 0)
    fechaHasta.setHours(0, 0, 0, 0)

    const esRangoValido = validarRangoFechas(hoy, fechaHasta, 'day')

    if (!esRangoValido) {
      return { vencido: true, mensaje: 'Lista vencida' }
    }

    const msPorDia = MS_SEGUNDO * SEGUNDOS_MINUTO * MINUTOS_HORA * HORAS_DIA
    const diasRestantes = Math.floor((fechaHasta - hoy) / msPorDia)
    if (diasRestantes <= DIAS_ALERTA) {
      return {
        vencido: false,
        mensaje: `Vence en ${diasRestantes} día${diasRestantes !== 1 ? 's' : ''}`
      }
    }

    return null
  }

  const estadoVencimiento = verificarVencimiento()

  if (esVenta) {
    return (
      <div className={styles.card}>
        <h4 className={styles.cardTitle}>{titulo}</h4>
        <div className={styles.cardBody}>
          <div className={styles.textMuted}>
            <p>
              <strong>Nombre: </strong>
              {titulo}
            </p>
            <p>
              <strong>Vigencia: </strong>
              {formatearFecha(lista.vigenciaDesde, 'F')} -{formatearFecha(lista.vigenciaHasta, 'F')}
            </p>

            <p>
              <strong>Vigencia oferta: </strong>
            </p>
            <p>
              {formatearFecha(lista.ofertaDesde, 'F')} -{formatearFecha(lista.ofertaHasta, 'F')}
            </p>
            <p>
              <strong>Descuento: </strong>
              {lista.porcDcto ?? '-'}%
            </p>
            {muestraNombreVendedor && (
              <p>
                <strong>Vendedor: </strong>
                {lista.nombreVendedor ?? '-'}
              </p>
            )}
            {estadoVencimiento && (
              <div
                className={`alert ${estadoVencimiento.vencido ? 'alert-danger' : 'alert-warning'} ${styles.alertVencimiento}`}
                role="alert"
              >
                {estadoVencimiento.mensaje}
              </div>
            )}
          </div>
        </div>

        {onEditar && (
          <div className={styles.btnContainer}>
            <button
              type="button"
              className={`${styles.btn} ${styles.btnOutlinePrimary}`}
              onClick={() => onEditar(lista)}
              title="Editar lista"
            >
              <i className="bi bi-pencil"></i>
            </button>
            {onVerItems && (
              <button
                type="button"
                className={`${styles.btn} ${styles.btnOutlinePrimary}`}
                onClick={() => onVerItems(lista)}
                title="Ver y editar publicaciones"
              >
                <i className="bi bi-list-ul"></i>
              </button>
            )}
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={styles.card}>
      <h4 className={styles.cardTitle}>{titulo}</h4>
      <div className={styles.cardBody}>
        <div className={styles.textMuted}>
          <p>
            <strong>Vigencia: </strong>
            {formatearFecha(lista.vigenciaDesde, 'F')} -{formatearFecha(lista.vigenciaHasta, 'F')}
          </p>
          <p>
            <strong> Cantidad de items lista: </strong>
            {cantidadItems ?? '-'}
          </p>
          {muestraNombreVendedor && (
            <p>
              <strong>Vendedor: </strong>
              {lista.nombreVendedor ?? '-'}
            </p>
          )}
          {estadoVencimiento && (
            <div
              className={`alert ${estadoVencimiento.vencido ? 'alert-danger' : 'alert-warning'} ${styles.alertVencimiento}`}
              role="alert"
            >
              {estadoVencimiento.mensaje}
            </div>
          )}
        </div>
      </div>

      <div className={styles.btnContainer}>
        <button
          type="button"
          className={`${styles.btn} ${styles.btnOutlinePrimary}`}
          onClick={() => onEditar(lista)}
        >
          <i className="bi bi-pencil"></i>
        </button>

        <button
          type="button"
          className={`${styles.btn} ${styles.btnOutlineDanger}`}
          onClick={() => onEliminar(lista)}
        >
          <i className="bi bi-trash"></i>
        </button>
      </div>
    </div>
  )
}

ItemLista.propTypes = {
  lista: PropTypes.object,
  onEditar: PropTypes.func,
  onEliminar: PropTypes.func,
  onVerItems: PropTypes.func,
  esVenta: PropTypes.bool,
  muestraNombreVendedor: PropTypes.bool
}
